import { motion } from "framer-motion";
import { Users, Briefcase, Wifi, ArrowUpRight, Route, Clock } from "lucide-react";
import { scrollToId } from "@/components/Nav";

const CHR_IMG = "https://images.unsplash.com/photo-1652509328308-7f0d7804e678?fm=jpg&q=80&w=2000&auto=format&fit=crop";

export const Fleet = () => (
  <section id="flotte" className="py-20 lg:py-32 bg-bone" data-testid="fleet-section">
    <div className="max-w-7xl mx-auto px-6 sm:px-12 lg:px-20">
      <motion.p
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.8, ease: [0.215, 0.61, 0.355, 1] }}
        className="text-xs uppercase tracking-[0.25em] font-mono text-amber-700/80 font-semibold mb-6"
      >
        Le véhicule
      </motion.p>
      <motion.h2
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.9, delay: 0.1, ease: [0.215, 0.61, 0.355, 1] }}
        className="font-serif font-light text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-[1.08] max-w-2xl mb-16"
      >
        Toyota C-HR, <span className="italic text-gold">hybride & confortable.</span>
      </motion.h2>
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-stretch">
        <motion.div
          initial={{ opacity: 0, y: 32 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.85, ease: [0.215, 0.61, 0.355, 1] }}
          className="lg:col-span-7 grid grid-rows-2 gap-8"
        >
          <div className="overflow-hidden group">
            <img src={CHR_IMG} alt="Toyota C-HR extérieur" className="w-full h-full min-h-[240px] object-cover group-hover:scale-105 transition-transform duration-700" loading="lazy" data-testid="fleet-vehicle-image" />
          </div>
          <div className="grid grid-cols-2 gap-8">
            <div className="overflow-hidden group">
              <img src="/interieur.jpeg" alt="Habitacle avant de la Toyota C-HR" className="w-full h-full min-h-[220px] object-cover group-hover:scale-105 transition-transform duration-700" loading="lazy" data-testid="fleet-interior-image" />
            </div>
            <div className="overflow-hidden group">
              <img src="/interieur2.jpeg" alt="Banquette arrière de la Toyota C-HR" className="w-full h-full min-h-[220px] object-cover group-hover:scale-105 transition-transform duration-700" loading="lazy" data-testid="fleet-rear-seats-image" />
            </div>
          </div>
        </motion.div>
        <motion.article
          initial={{ opacity: 0, y: 32 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.85, delay: 0.12, ease: [0.215, 0.61, 0.355, 1] }}
          className="lg:col-span-5 bg-white border border-[#E6E1D8] p-8 lg:p-10 flex flex-col"
          data-testid="fleet-card-chr"
        >
          <h3 className="text-xl font-medium text-obsidian mb-2">Toyota C-HR Hybride</h3>
          <p className="text-sm text-neutral-600 leading-relaxed mb-8">SUV hybride récent, silencieux en ville et confortable sur longue distance. Idéal seul, en couple ou en petit groupe.</p>
          <div className="flex flex-wrap gap-x-5 gap-y-2 mb-8">
            <span className="flex items-center gap-1.5 text-xs text-neutral-600"><Users size={13} className="text-gold" /> 4 passagers</span>
            <span className="flex items-center gap-1.5 text-xs text-neutral-600"><Briefcase size={13} className="text-gold" /> 3 bagages</span>
            <span className="flex items-center gap-1.5 text-xs text-neutral-600"><Wifi size={13} className="text-gold" /> Chargeurs & eau</span>
          </div>
          <div className="space-y-4 border-t border-[#E6E1D8] pt-8 mb-10">
            <div className="flex items-center justify-between">
              <span className="flex items-center gap-2 text-sm text-neutral-600"><Route size={14} className="text-gold" /> Course (court ou long trajet)</span>
              <span className="text-sm font-medium text-obsidian" data-testid="fleet-rate-km">Tarif fixe</span>
            </div>
            <div className="flex items-center justify-between">
              <span className="flex items-center gap-2 text-sm text-neutral-600"><Clock size={14} className="text-gold" /> Mise à disposition</span>
              <span className="font-serif text-2xl text-obsidian" data-testid="fleet-rate-hour">70 €<span className="text-sm text-neutral-500 font-sans">/h</span></span>
            </div>
          </div>
          <button
            data-testid="fleet-select-chr"
            onClick={() => scrollToId("#reservation")}
            className="mt-auto flex items-center justify-between border border-obsidian text-obsidian text-xs uppercase tracking-[0.2em] px-5 py-3.5 hover:bg-obsidian hover:text-cream transition-colors duration-300"
          >
            Réserver ce véhicule <ArrowUpRight size={14} />
          </button>
        </motion.article>
      </div>
    </div>
  </section>
);
